export default __webpack_public_path__ + "static/media/siminn-icons.0d0f0c52.woff";